import { StepperMainTool } from 'modules/main/domain/utils/stepper-tool';
import { Pages } from 'modules/navigation/domain/enums/pages';
import { organizerIsTeamCreatingSelector } from 'modules/organizer/store/orginizer/selectors';
import { useOrganizer } from 'modules/organizer/ui/hooks/use-organizer';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { AppDispatch } from 'store/store';
import UDHeaderTitle from 'ud-ui/components/header-title';
import { useMainLayout } from 'ud-ui/layout/main/context';
import { Team } from '../../domain/interfaces/team';
import TeamForm, { SubmitTeamForm } from '../components/team-form/team-form';
import { createTeam } from 'modules/teams/store/teams';

const TeamsCreatePage = () => {
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();
  const { setHeaderContent } = useMainLayout();

  const { info } = useOrganizer();
  const isCreating = useSelector(organizerIsTeamCreatingSelector);
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = useCallback<SubmitTeamForm>(
    ({ values, formikHelpers }) => {
      if (!info?.id) {
        toast.error('Турнир не найден. Попробуйте перезагрузить страницу.');
        return;
      }

      const logo = values.logo?.[0] && values.logo[0] instanceof File ? (values.logo[0] as File) : undefined;

      setIsLoading(true);
      dispatch(
        createTeam({
          tournamentId: info.id,
          name: values.name,
          logo,
        }),
      )
        .unwrap()
        .then((data) => {
          StepperMainTool.setByPath('stepper:main:createTeam', true);
          navigate(Pages.TEAMS.builders.edit((data as Team)?.id));
        })
        .finally(() => {
          setIsLoading(false);
          formikHelpers.setSubmitting(false);
        });
    },
    [dispatch, info?.id, navigate],
  );

  useEffect(() => {
    setHeaderContent(<UDHeaderTitle>Добавление команды</UDHeaderTitle>);
    return () => setHeaderContent(null);
  }, [setHeaderContent]);

  return (
    <>
      <div className="h-100 container pt-6">
        {info && (
          <div className="h-100">
            {/* <CreateTeamForm tournamentId={info.id} /> */}
            <TeamForm onSubmit={onSubmit} isLoading={isLoading || isCreating} />
          </div>
        )}
      </div>
    </>
  );
};

export default TeamsCreatePage;
